import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from "rxjs";
import { Router } from "@angular/router";
import { CanEnterGuard } from "@app/@core/services/auth/can-enter-guard/can-enter.guard";
import { IImageUploadSuccess, IImageUploadSuccessResponse } from "@app/@shared/Models/form-data.model";
import { PageViewTrackingEvent, TrackingInput } from "@app/@core/models/tracking-event.model";
import { InstrumentationService } from "@app/@core/services/instrumentation/instrumentation.service";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  private maxAllowedRangeError = new BehaviorSubject(false);
  getRange = this.maxAllowedRangeError.asObservable();
  isSellerRevampEnabled = true;


  public revampedJourney$ : Observable<boolean>;
  private revampedJourneySource: BehaviorSubject<boolean>;

  constructor(private http: HttpClient, private router: Router, private instrumentationService: InstrumentationService) {
    this.revampedJourneySource = new BehaviorSubject<boolean>(false);
    this.revampedJourney$ = this.revampedJourneySource.asObservable();
  }

  public isRevampedJourney(): boolean {
      return this.revampedJourneySource.value;
  }

  public setRevampedJourney(value: boolean) : void {
    const previous = this.revampedJourneySource.value;
    this.revampedJourneySource.next(value);
    console.log(this.router.config)
    if(previous === this.revampedJourneySource.value) {
      return
    }
    const  index = this.router.config.findIndex(x => x.path === 'dashboard');

    let orderIndex = this.router.config[index]['_loadedConfig'].routes[0].children.findIndex(x => x.path === 'orders');
    this.router.config[index]['_loadedConfig'].routes[0].children.splice(orderIndex, 1);
    this.router.config[index]['_loadedConfig'].routes[0].children.push(
      {
        path: 'orders',
        loadChildren: () =>
          import('../../order-handler/order-handler.module').then((m) => m.OrderHandlerModule),
      }
    )
  }

  changeMaxAllowedRange(message: any) {
    this.maxAllowedRangeError.next(message)
  }

  getFromMediaStore(imageKey) {
    const url = environment.without_auth_url + '/cmedia-store/files/' + imageKey;
    return url;
  }

  uploadToMediaStore(requesBody) {
    return this.http.post(
      environment.with_auth_url + '/media-store/files',
      requesBody
    );
  }

  uploadImage(
    requestBody: FormData
  ): Observable<IImageUploadSuccessResponse<IImageUploadSuccess>> {
    return this.http.post<IImageUploadSuccessResponse<IImageUploadSuccess>>(
        `${environment.with_auth_url}/seller/catalog-upload`,
        requestBody
    );
  }

  getSellerPersonalDetails() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/profile/getPersonalDetails');
  }

  getSellerProfileDetails() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/profile/getAllDetails');
  }

  saveNewAddressByOrgId(requestBody) {
    return this.http.post(environment.with_auth_url + '/seller/api/v1/profile/address', requestBody);
  }

  updateAddressByOrgIdAndAddressId(addressId, requestBody) {
    return this.http.put(environment.with_auth_url + '/seller/api/v1/profile/address?addressId=' + addressId, requestBody);
  }

  getBankDetailsByOrgId() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/profile/getBankDetails');
  }

  saveBankDetailsByOrgId(requestBody) {
    return this.http.post(environment.with_auth_url + '/seller/api/v1/profile/bank', requestBody);
  }

  updateBankDetailsByOrgId(requestBody) {
    return this.http.put(environment.with_auth_url + '/seller/api/v1/profile/bank', requestBody);
  }

  updateProfileDetailsByOrgId(requestBody) {
    return this.http.put(environment.with_auth_url + '/seller/api/v1/profile/updateProfileByOrgId', requestBody);
  }

  getCityAndStateByPincode(pincode) {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/profile/getCityAndStateByPincode?pincode=' + pincode);
  }

  getSolvScoreByOrgId() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/profile/getSolvScore');
  }

  getAllBusinessCategory() {
    return this.http.get(environment.with_auth_url + '/business-data/api/v1/business-category');
  }

  getAddressByOrgId() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/profile/getAddressByOrgId');
  }

  getAllUser() {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/secondary-user');
  }

  postUser(requestPayload) {
    return this.http.post(environment.with_auth_url + '/seller/api/v1/secondary-user', requestPayload);
  }

  deleteUser(userId) {
    return this.http.put(environment.with_auth_url + '/seller/api/v1/secondary-user?userId=' + userId, {});
  }

  saveAd(requestPayload){
//   /*
//     const headers= new HttpHeaders({
//         'referenceId':  sessionStorage.getItem('orgId')
//     });
//
//     */
    return this.http.post(environment.with_auth_url + '/seller/api/v1/inventory/addAddress',requestPayload);
  }
  updateAddress(addressId,requestPayload, editFlag) {
    let params = new HttpParams();
    params = params.append('editFlag', editFlag);
    const url = environment.with_auth_url + '/seller/api/v1/inventory/updateAddress/'+addressId;
    return this.http.put(url, requestPayload,{ params:params });
  }
  getAddressConfig() {
    // let timeStamp = new Date().getTime().toString();
    const headers = new HttpHeaders(
      {
        'referenceId': 'fa89be58-14f0-4ad2-8c31-677d4fdd0927',
        'requestId':  '454545'
      })
    // const httpOptions = {
    //   headers: new HttpHeaders({
    //     'referenceId': 'fa89be58-14f0-4ad2-8c31-677d4fdd0927',
    //     'requestId':  '454545'
    //   })
    // };
   // const URL = 'https://dev-api.solvezy.net/dev/seller/api/v1/inventory/getAddressConfig';
    const URL = environment.with_auth_url + '/seller/api/v1/inventory/getAddressConfig';
    return this.http.get(URL,{headers:headers});
  }

  getAddByRefId() {
    const refId = sessionStorage.getItem('orgId');
    const URL = environment.with_auth_url + '/seller/api/v1/inventory/reference/' + refId;
    return this.http.get(URL);
  }
  deleteAddById(addressId) {
    const URL = environment.with_auth_url + '/seller/api/v1/inventory/deleteAddress/' + addressId;
    return this.http.delete(URL);
  }

    saveFreshChatRestoreId(freshChatRestoreId) {
        const headers = new HttpHeaders({
            'referenceId': sessionStorage.getItem('orgId')
        });
        return this.http.post(environment.with_auth_url + '/seller/api/v1/seller/save-restore-id?restore_id=' + freshChatRestoreId, {});
    }

  /**
   * @description : logout API to invalidate user session on server
   * @param clientId    [string] : mobile no
   * @param userId      [string] : org id
   * @param accessToken [string] : access token
   */
  logoutUser(payload: {clientId: string, userId: string, accessToken: string}): Observable<any> {
    const url = environment.with_auth_url + '/user-onboarding/api/v1/sign-out';
    return this.http.post(url, payload);
  }
  logPageViewEvent(pageName): void{
    const trackingInput: TrackingInput<PageViewTrackingEvent> = {
        eventLabel: 'Page Viewed',
        eventName: 'PAGE_VIEWED',
        eventSource: 'Menu Bar',
        pageName: pageName,
        viewedAt: Date.now()
    };
    this.instrumentationService.logEvent<PageViewTrackingEvent>(trackingInput);
  }

}
